export default "__VITE_ASSET__C3OOtxM1__"